import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAutenticacao } from '../context/autenticacao_contexto';
import { Box, CircularProgress } from '@mui/material';

const RotaProtegida = ({ children }) => {
    const { perfilUsuario, carregandoSessao } = useAutenticacao();

    if (carregandoSessao) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!perfilUsuario) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default RotaProtegida;